import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

const ServerError = () => {
  const { t } = useTranslation();

  return (
    <div className="GenericPage">
      <h1>{t('pages.500.title')}</h1>
      <p>{t('pages.500.body', { pagename: window.location.href })}</p>
      <div className="GenericPage__links">
        <Button primary href={t('pages.500.primary_button.url')} className="icon-after icon-arrow icon-variant-1">{t('pages.500.primary_button.link')}</Button>
      </div>
    </div>
  );
};

export default ServerError;
